/** @module csi/widget/_svg/ModePoints */
define([
	"dijit/form/ToggleButton",
	"csi/locale",
	"csi/message",
	"csi/widget/MessageDialog",
	"./_Plugin",
	"./PluginFactory",
	"./util"
], function(ToggleButton,locale,message,MessageDialog,_Plugin,PluginFactory,util) {

	return PluginFactory.declare([ToggleButton,_Plugin], {
		"class": "csi-button-toggle csi-single-toggle",
		bHideWhenDisabled: true,
		iconClass: "csiActionIcon svgIconPoints",
		pluginName: "points",
		title: "CanvasEditPoints",

		/**
		 * Only allow if this is edit mode for selected shape
		 */
		enablePlugin: function(shapes, shapeAttrs, textAttrs) {
			this.set('checked', this.editor.isEditCurveCanvasMode());

			if (shapes && shapes.length > 0) {
				return this.editor.isSelectedShapesSupportEditPoints() && !this.editor.isSelectedShapeFromPlaceholder();
			}
			return false;
		},

		/**
		 * Edit selected page object.
		 */
		onClick: function() {
			this.editor.editPointsPageObject();
		}
	});
});
